var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 20.1663C16.0627 20.1663 20.1666 16.0624 20.1666 10.9997C20.1666 5.93692 16.0627 1.83301 10.9999 1.83301C5.93717 1.83301 1.83325 5.93692 1.83325 10.9997C1.83325 16.0624 5.93717 20.1663 10.9999 20.1663Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8916 12.4671C8.8916 13.2921 9.53327 13.9337 10.3583 13.9337H11.9166C12.5583 13.9337 13.1999 13.3837 13.1999 12.6504C13.1999 11.8254 12.8333 11.5504 12.3749 11.3671L9.80827 10.4504C9.1666 10.3587 8.8916 10.0837 8.8916 9.35039C8.8916 8.61706 9.4416 8.06706 10.1749 8.06706H11.8249C12.6499 8.06706 13.2916 8.70872 13.2916 9.53372M10.9999 7.15039V14.8504",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin_icon.cf46cce8170d386e20b865314cb90eb6.svg";
export { ForwardRef as ReactComponent };